<template>
	<div>

		<div class="header__container">
			<div class="header" style="position: relative">
				Verhoudingen
			</div>
			<div class="subHeader" style="position: relative">
				De juiste aarde
			</div>
			<div class="text" style="position: relative">
				Gek om zo naar de wereld te kijken, he? Hieronder zie je de situatie in 2017.
			</div>
		</div>
		<div class="explanation mainTitle" style="position: relative"/>

		<div class="panel">
			<table >
				<tr v-for="(name, i) in names">
					<td>
						<div class="feedback__icon">
							<div class="feedback__icon__text">{{Math.round((correctScores[i]/totalScores)*100)}}%</div>
							<img :src="baseUrl + questionData.items[i].visual"/>
						</div>
					</td>
					<td>
						<p style="padding: 2px"><b>{{names[i].replace(/_/g," ")}}</b> (Jij had {{Math.round((currentScores[i]/totalScores)*100)}}%)</p>
						<p>{{feedbackArray[i]}}</p>
					</td>
				</tr>
			</table>

		</div>
	</div>
</template>

<script>

	import Lottie from '../../Lottie.vue';
	import { url} from '../../../const/base';
	import {mapGetters , mapActions} from 'vuex';

	export default {

		props:[
			'correctScores',
			'currentScores',
			'names',
			'totalScores',
		],

		components:{
			Lottie,
		},

		mounted(){
			this.setFeedback();
		},
		data(){
			return {
				baseUrl : url,
				feedbackArray : []
			}
		},
		methods:{
			...mapActions([
			]),

			setFeedback(){
				for(let i = 0 ; i < this.names.length ; i++){
					switch(i){
						case 0://Industrie
							if(this.currentScores[i] > +this.correctScores[i])
								this.feedbackArray.push("Industrie te hoog.");
							else if(this.currentScores[i] < +this.correctScores[i])
								this.feedbackArray.push("Industrie te laag.");
							else
								this.feedbackArray.push("Industrie perfect.");
							break;
						case 1://Landbouw
							if(this.currentScores[i] > +this.correctScores[i])
								this.feedbackArray.push("Landbouw te hoog.");
							else if(this.currentScores[i] < +this.correctScores[i])
								this.feedbackArray.push("Landbouw te laag.");
							else
								this.feedbackArray.push("Landbouw perfect.");
							break;
						case 2://Natuur
							if(this.currentScores[i] > +this.correctScores[i])
								this.feedbackArray.push("Natuur te hoog.");
							else if(this.currentScores[i] < +this.correctScores[i])
								this.feedbackArray.push("Natuur te laag.");
							else
								this.feedbackArray.push("Natuur perfect.");
							break;
						case 3://Onbruikbare grond
							if(this.currentScores[i] > +this.correctScores[i])
								this.feedbackArray.push("Onbruikbare grond te hoog.");
							else if(this.currentScores[i] < +this.correctScores[i])
								this.feedbackArray.push("Onbruikbare grond te laag.");
							else
								this.feedbackArray.push("Onbruikbare grond perfect.");
							break;
					}
				}
			}
		},
		computed:{
			...mapGetters([
				"questionData",
			]),
		},

	}
</script>

<style scoped>

	p{
		padding: 5px;
	}

	td{
		text-align: left;
		vertical-align: top;
		padding: 10px;
	}

	.feedback__icon{
		width: 80px;
		height: 80px;
		border-radius: 80px;
		box-shadow: 0px 0px 10px 2px #eee;
		position: relative;
	}


	.feedback__icon__text{
		padding-left: 5px;
		height: 100%;
		position: absolute;
		text-align: center;
		line-height: 80px;
		font-size: 22px;
		font-weight: 800;
		z-index: 2;
	}

	.feedback__icon img{
		width: 30px;
		position: relative;
		left: calc(50% - 15px);
		top: 20px;/*calc(50% - 20px);*/
		opacity: 0.5;
	}

	@media screen and (max-width: 360px) {
		p{
			padding: 2px;
		}

		td{
			padding: 4px;
		}

		.feedback__icon{
			width: 40px;
			height: 40px;
			border-radius: 40px;
		}

		.feedback__icon__text{
			line-height: 40px;
		}

		.feedback__icon img{
			width: 20px;
			position: relative;
			left: calc(50% - 10px);
			top: 5px;/*calc(50% - 20px);*/
			opacity: 0.5;
		}
	}

</style>


// WEBPACK FOOTER //
// src/components/minigames/landmark/Feedback.vue